export const FETCH_BANNERS = 'FETCH_BANNERS'
export const FETCH_MOVIES = 'FETCH_MOVIES'
export const FETCH_INFOR_THEATER = 'FETCH_INFOR_THEATER'
export const FETCH_SCHEDULE_DETAIL = 'FETCH_SCHEDULE_DETAIL';
export const FETCH_DETAIL_MOVIE = "FETCH_DETAIL_MOVIE"
export const FETCH_LIST_SEAT = 'FETCH_LIST_SEAT'

export const ORDER_SEAT = 'ORDER_SEAT'
export const POST_INFO_BOOK_TICKET = 'POST_INFO_BOOK_TICKET'
export const DISPLAY_LOADING = "DISPLAY_LOADING";
export const HIDDEN_LOADDING = 'HIDDEN_LOADDING';
export const COMPLETE_CHECKOUT = 'COMPLETE_CHECKOUT'
export const COMPLETE_CHECKOUT2 = 'COMPLETE_CHECKOUT2'
export const SET_DEFAULT_TAB = 'SET_DEFAULT_TAB'
export const CLEAR_ORDER_SEAT ='CLEAR_ORDER_SEAT'